module.exports = __webpack_public_path__ + "static/img/1620_phase_function_Paper_PointsHejduk_Prediction.497cd9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1620_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Kw+h
// module chunks = 0